// import React, { useState, useEffect } from "react";
// import { MapPin } from "lucide-react";
// import "../../styles/mapcomponent/map.css";
// import RwandaMap from "../../assets/img/rwanda-geojson.svg";
// import { Icon } from "@iconify/react/dist/iconify.js";
// import axios from "axios";
// import Cookies from "js-cookie";

// const MapComponent = ({ onLocationClick, activeTab }) => {
//   const [hoveredRegion, setHoveredRegion] = useState(null);
//   const [sites, setSites] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

//   const baseUrl = process.env.REACT_APP_BASE_URL;

//   const formatNumber = (num) => {
//     const parsedNum = Number(num);
//     if (isNaN(parsedNum) || num === undefined || num === null) {
//       return "0";
//     }
//     return parsedNum.toLocaleString("en-US");
//   };

//   useEffect(() => {
//     const getActiveSites = async () => {
//       setLoading(true);
//       setError(null);
//       setSites([]);
//       try {
//         const token = Cookies.get("token");
//         const endpoint =
//           activeTab === "approved" || !activeTab
//             ? `${baseUrl}/api/sites/active/approved`
//             : `${baseUrl}/api/sites/active`;
//         const response = await axios.get(endpoint, {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         const activeSites = response.data
//           .map((site) => ({
//             lat: site.latitude,
//             lng: site.longitude,
//             district: site.district,
//             province: site.province,
//             name: site.name,
//             sector: site.sector,
//             percentage: formatNumber(site.percentage),
//           }))
//           .filter(
//             (site, index, self) =>
//               index === self.findIndex((s) => s.sector === site.sector)
//           );
//         if (response.status === 200) {
//           setSites(activeSites);
//         } else {
//           throw new Error("Failed to fetch sites");
//         }
//       } catch (err) {
//         setError("Failed to fetch sites");
//       } finally {
//         setLoading(false);
//       }
//     };

//     getActiveSites();
//   }, [activeTab, baseUrl]);

//   const convertToSVGCoordinates = (lat, lng) => {
//     // Rwanda's approximate bounding box
//     const bounds = {
//       minLat: -2.86,
//       maxLat: -1.0,
//       minLng: 28.84,
//       maxLng: 30.9
//     };
    
//     // SVG viewBox dimensions
//     const svgWidth = 406;
//     const svgHeight = 356;

//     // Convert coordinates to SVG space
//     const x = ((lng - bounds.minLng) / (bounds.maxLng - bounds.minLng)) * svgWidth;
//     const y = ((bounds.maxLat - lat) / (bounds.maxLat - bounds.minLat)) * svgHeight;

//     return { x, y };
//   };

//   const handleMouseEnter = (site, event) => {
//     setHoveredRegion(site);
//     const coords = convertToSVGCoordinates(site.lat, site.lng);
//     setTooltipPosition({
//       x: coords.x,
//       y: coords.y - 10,
//     });
//   };

//   const handleMouseLeave = () => {
//     setHoveredRegion(null);
//   };

//   return (
//     <div className="rwanda-map">
//       <svg viewBox="0 0 408 358" className="rwanda-map__svg">
//         <defs>
//           <pattern
//             id="dotPattern"
//             x="0"
//             y="0"
//             width="10"
//             height="10"
//             patternUnits="userSpaceOnUse"
//           >
//             <circle cx="5" cy="5" r="1" fill="#E6E6FF" />
//           </pattern>
//           <clipPath id="mapClip">
//             <image
//               href={RwandaMap}
//               x="0"
//               y="0"
//               width="400"
//               height="400"
//               preserveAspectRatio="xMidYMid meet"
//             />
//           </clipPath>
//         </defs>

//         <rect
//           x="0"
//           y="0"
//           width="500"
//           height="500"
//           fill="url(#dotPattern)"
//           clipPath="url(#mapClip)"
//         />

//         <image
//           href={RwandaMap}
//           x="0"
//           y="0"
//           width="100%"
//           height="100%"
//           preserveAspectRatio="xMidYMid meet"
//         />

//         {sites.map((site, index) => {
//           const coords = convertToSVGCoordinates(site.lat, site.lng);
//           if (!coords) return null;
//           return (
//             <g
//               key={index}
//               className="rwanda-map__location-marker"
//               onClick={() => onLocationClick?.(site)}
//             >
//               <circle
//                 cx={coords.x}
//                 cy={coords.y}
//                 r="6"
//                 className="rwanda-map__location-marker__pulse"
//                 style={{
//                   transformBox: "fill-box",
//                   transformOrigin: "center",
//                 }}
//               />

//               <circle
//                 cx={coords.x}
//                 cy={coords.y}
//                 r="4"
//                 className="rwanda-map__location-marker__middle"
//                 onMouseEnter={(e) => handleMouseEnter(site, e)}
//                 onMouseLeave={handleMouseLeave}
//               />

//               <circle
//                 cx={coords.x}
//                 cy={coords.y}
//                 r="2"
//                 className="rwanda-map__location-marker__center"
//                 onMouseEnter={(e) => handleMouseEnter(site, e)}
//                 onMouseLeave={handleMouseLeave}
//               />
//             </g>
//           );
//         })}

//         {hoveredRegion && (
//           <g
//             filter="url(#shadow)"
//             className="rwanda-map__tooltip"
//             transform={`translate(${tooltipPosition.x}, ${tooltipPosition.y})`}
//           >
//             <defs>
//               <filter id="shadow">
//                 <feDropShadow
//                   dx="0"
//                   dy="2"
//                   stdDeviation="2"
//                   floodColor="rgba(0,0,0,0.2)"
//                 />
//               </filter>
//             </defs>
//             <rect
//               x="-120"
//               y="-130"
//               width="240"
//               height="130"
//               rx="12"
//               ry="12"
//               fill="white"
//             />
//             <polygon points="0,6 -8,-6 8,-6" fill="white" />

//             <g className="tooltip-header">
//               <rect
//                 x="-100"
//                 y="-105"
//                 width="200"
//                 height="20"
//                 rx="13"
//                 ry="13"
//                 fill="#078ECE33"
//               />
//               <text
//                 x="0"
//                 y="-92"
//                 textAnchor="middle"
//                 fill="#078ECE"
//                 fontSize="12"
//                 fontWeight="600"
//               >
//                 Province: {hoveredRegion.province}
//               </text>
//               <rect
//                 x="-100"
//                 y="-80"
//                 width="200"
//                 height="20"
//                 rx="13"
//                 ry="13"
//                 fill="#078ECE33"
//               />
//               <text
//                 x="0"
//                 y="-67"
//                 textAnchor="middle"
//                 fill="#078ECE"
//                 fontSize="12"
//                 fontWeight="600"
//               >
//                 District: {hoveredRegion.district}
//               </text>
//               {hoveredRegion.sector && (
//                 <>
//                   <rect
//                     x="-100"
//                     y="-55"
//                     width="200"
//                     height="20"
//                     rx="13"
//                     ry="13"
//                     fill="#078ECE33"
//                   />
//                   <text
//                     x="0"
//                     y="-42"
//                     textAnchor="middle"
//                     fill="#078ECE"
//                     fontSize="12"
//                     fontWeight="600"
//                   >
//                     Sector: {hoveredRegion.sector}
//                   </text>
//                 </>
//               )}
//             </g>
            
//             <g className="tooltip-content">
//               <text
//                 x="0"
//                 y="-15"
//                 textAnchor="middle"
//                 fill="#6B7280"
//                 fontWeight="500"
//               >
//                 SCANNED RECORDS: {hoveredRegion.percentage}
//               </text>
//             </g>
//           </g>
//         )}
//       </svg>
//     </div>
//   );
// };

// export default MapComponent;




import React, { useState, useEffect, useRef } from "react";
import { MapPin } from "lucide-react";
import "../../styles/mapcomponent/map.css";
import RwandaMap from "../../assets/img/rwanda-geojson.svg";
import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import Cookies from "js-cookie";

const MapComponent = ({ onLocationClick, activeTab }) => {
  const [hoveredRegion, setHoveredRegion] = useState(null);
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const mapContainerRef = useRef(null);
  const svgRef = useRef(null);

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const formatNumber = (num) => {
    const parsedNum = Number(num);
    if (isNaN(parsedNum) || num === undefined || num === null) {
      return "0";
    }
    return parsedNum.toLocaleString("en-US");
  };

  useEffect(() => {
    const getActiveSites = async () => {
      setLoading(true);
      setError(null);
      setSites([]);
      try {
        const token = Cookies.get("token");
        const endpoint =
          activeTab === "approved" || !activeTab
            ? `${baseUrl}/api/sites/active/approved`
            : `${baseUrl}/api/sites/active`;
        const response = await axios.get(endpoint, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const activeSites = response.data
          .map((site) => ({
            lat: site.latitude,
            lng: site.longitude,
            district: site.district,
            province: site.province,
            name: site.name,
            sector: site.sector,
            percentage: formatNumber(site.percentage),
          }))
          .filter(
            (site, index, self) =>
              index === self.findIndex((s) => s.sector === site.sector)
          );
        if (response.status === 200) {
          setSites(activeSites);
        } else {
          throw new Error("Failed to fetch sites");
        }
      } catch (err) {
        setError("Failed to fetch sites");
      } finally {
        setLoading(false);
      }
    };

    getActiveSites();
  }, [activeTab, baseUrl]);

  const convertToSVGCoordinates = (lat, lng) => {
    const bounds = {
      minLat: -2.86,
      maxLat: -1.0,
      minLng: 28.84,
      maxLng: 30.9
    };
    
    const svgWidth = 406;
    const svgHeight = 356;

    const x = ((lng - bounds.minLng) / (bounds.maxLng - bounds.minLng)) * svgWidth;
    const y = ((bounds.maxLat - lat) / (bounds.maxLat - bounds.minLat)) * svgHeight;

    return { x, y };
  };

  const getTooltipPosition = (siteCoords, hasSector) => {
    const svgWidth = 406;
    const svgHeight = 356;
    const tooltipWidth = 160;
    const tooltipHeight = hasSector ? 85 : 70;
    const padding = 15;

    let x = siteCoords.x;
    let y = siteCoords.y - tooltipHeight - 20;

    // Adjust horizontal position if tooltip would overflow
    if (x + tooltipWidth / 2 > svgWidth - padding) {
      x = svgWidth - tooltipWidth / 2 - padding;
    } else if (x - tooltipWidth / 2 < padding) {
      x = tooltipWidth / 2 + padding;
    }

    // Adjust vertical position if tooltip would overflow top
    if (y < padding) {
      y = siteCoords.y + 20; // Position below the marker
    }

    return { x, y, isBelow: y > siteCoords.y };
  };

  const handleMouseEnter = (site, event) => {
    setHoveredRegion(site);
    const coords = convertToSVGCoordinates(site.lat, site.lng);
    const position = getTooltipPosition(coords, !!site.sector);
    setTooltipPosition({ ...position, markerX: coords.x, markerY: coords.y });
  };

  const handleMouseLeave = () => {
    setHoveredRegion(null);
  };

  return (
    <div className="rwanda-map" ref={mapContainerRef}>
      <svg viewBox="0 0 408 358" className="rwanda-map__svg" ref={svgRef}>
        <defs>
          <pattern
            id="dotPattern"
            x="0"
            y="0"
            width="10"
            height="10"
            patternUnits="userSpaceOnUse"
          >
            <circle cx="5" cy="5" r="1" fill="#E8F0FE" />
          </pattern>
          <clipPath id="mapClip">
            <image
              href={RwandaMap}
              x="0"
              y="0"
              width="400"
              height="400"
              preserveAspectRatio="xMidYMid meet"
            />
          </clipPath>
          <filter id="tooltipShadow">
            <feDropShadow
              dx="0"
              dy="4"
              stdDeviation="8"
              floodColor="rgba(0,0,0,0.12)"
            />
          </filter>
          <linearGradient id="markerGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#3b82f6" stopOpacity="1" />
            <stop offset="100%" stopColor="#2563eb" stopOpacity="1" />
          </linearGradient>
        </defs>

        <rect
          x="0"
          y="0"
          width="500"
          height="500"
          fill="url(#dotPattern)"
          clipPath="url(#mapClip)"
        />

        <image
          href={RwandaMap}
          x="0"
          y="0"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid meet"
        />

        {sites.map((site, index) => {
          const coords = convertToSVGCoordinates(site.lat, site.lng);
          if (!coords) return null;
          return (
            <g
              key={index}
              className="rwanda-map__location-marker"
              onClick={() => onLocationClick?.(site)}
            >
              <circle
                cx={coords.x}
                cy={coords.y}
                r="8"
                className="rwanda-map__location-marker__pulse"
              />

              <circle
                cx={coords.x}
                cy={coords.y}
                r="5"
                fill="transparent"
                className="rwanda-map__location-marker__hover-area"
                onMouseEnter={(e) => handleMouseEnter(site, e)}
                onMouseLeave={handleMouseLeave}
              />

              <circle
                cx={coords.x}
                cy={coords.y}
                r="5"
                className="rwanda-map__location-marker__middle"
                style={{ pointerEvents: 'none' }}
              />

              <circle
                cx={coords.x}
                cy={coords.y}
                r="2.5"
                className="rwanda-map__location-marker__center"
                style={{ pointerEvents: 'none' }}
              />
            </g>
          );
        })}

        {hoveredRegion && (
          <g
            className="rwanda-map__tooltip"
            filter="url(#tooltipShadow)"
          >
            <rect
              x={tooltipPosition.x - 80}
              y={tooltipPosition.y}
              width="160"
              height={hoveredRegion.sector ? "85" : "70"}
              rx="8"
              fill="white"
              stroke="#E5E7EB"
              strokeWidth="1"
            />
            
            {/* Arrow pointing to marker */}
            {tooltipPosition.isBelow ? (
              <polygon 
                points={`${tooltipPosition.markerX},${tooltipPosition.markerY + 8} ${tooltipPosition.markerX - 5},${tooltipPosition.y} ${tooltipPosition.markerX + 5},${tooltipPosition.y}`}
                fill="white"
                stroke="#E5E7EB"
                strokeWidth="1"
              />
            ) : (
              <polygon 
                points={`${tooltipPosition.markerX},${tooltipPosition.markerY - 8} ${tooltipPosition.markerX - 5},${tooltipPosition.y + (hoveredRegion.sector ? 85 : 70)} ${tooltipPosition.markerX + 5},${tooltipPosition.y + (hoveredRegion.sector ? 85 : 70)}`}
                fill="white"
                stroke="#E5E7EB"
                strokeWidth="1"
              />
            )}

            <g className="tooltip-content">
              {/* Province */}
              <rect
                x={tooltipPosition.x - 70}
                y={tooltipPosition.y + 10}
                width="140"
                height="16"
                rx="4"
                fill="#078ECE33"
              />
              <text
                x={tooltipPosition.x}
                y={tooltipPosition.y + 20}
                textAnchor="middle"
                fill="#078ECE"
                fontSize="8"
                fontWeight="600"
              >
                {hoveredRegion.province}
              </text>

              {/* District */}
              <rect
                x={tooltipPosition.x - 70}
                y={tooltipPosition.y + 28}
                width="140"
                height="16"
                rx="4"
                fill="#078ECE33"
              />
              <text
                x={tooltipPosition.x}
                y={tooltipPosition.y + 38}
                textAnchor="middle"
                fill="#078ECE"
                fontSize="8"
                fontWeight="600"
              >
                {hoveredRegion.district}
              </text>

              {/* Sector */}
              {hoveredRegion.sector && (
                <>
                  <rect
                    x={tooltipPosition.x - 70}
                    y={tooltipPosition.y + 46}
                    width="140"
                    height="16"
                    rx="4"
                    fill="#078ECE33"
                  />
                  <text
                    x={tooltipPosition.x}
                    y={tooltipPosition.y + 56}
                    textAnchor="middle"
                    fill="#078ECE"
                    fontSize="8"
                    fontWeight="600"
                  >
                    {hoveredRegion.sector}
                  </text>
                </>
              )}

              {/* Scanned records */}
              <text
                x={tooltipPosition.x}
                y={tooltipPosition.y + (hoveredRegion.sector ? 72 : 57)}
                textAnchor="middle"
                fill="#6B7280"
                fontSize="8"
                fontWeight="500"
                marginTop="8"
              >
                <tspan fill="#6B7280">SCANNED RECORDS: </tspan>
                <tspan fill="#6B7280">{hoveredRegion.percentage}</tspan>
              </text>
            </g>
          </g>
        )}
      </svg>
    </div>
  );
};

export default MapComponent;